
import ButtonBlue from "@/components/ButtonBlue.vue";
import { defineComponent } from "vue";

export default defineComponent({
  components: {
    ButtonBlue,
  },
});
